import type { CrucePerfil } from '../services/api';

export function GraficoCompaneros({ companeros, onVerPerfil }: {
  companeros: CrucePerfil[]; onVerPerfil: (id: number) => void;
}) {
  const conMuestra = companeros.filter(c => !c.poca_muestra).sort((a, b) =>
    b.ganados / b.partidos - a.ganados / a.partidos || b.partidos - a.partidos || a.id - b.id);
  const pocos = companeros.filter(c => c.poca_muestra);
  return <div role="group" aria-label="Resultados con compañeros" className="flex flex-col gap-3">
    {conMuestra.length ? conMuestra.map(c => <button type="button" key={c.id} onClick={() => onVerPerfil(c.id)}
      className="flex min-h-16 flex-col gap-1 rounded-xl p-1 text-left active:bg-white/5">
      <span className="flex justify-between gap-2 text-sm font-bold"><span className="min-w-0 break-words underline decoration-(--color-borde)">{c.nombre}</span>
        <span>{Math.round(c.ganados / c.partidos * 100)}%</span></span>
      <span aria-hidden="true" className="h-2.5 overflow-hidden rounded-full bg-(--color-borde)">
        <span className="block h-full rounded-full bg-(--color-acento)" style={{ width: `${c.ganados / c.partidos * 100}%` }} />
      </span>
      <span className="text-xs text-(--color-apagado)">{c.ganados} G · {c.perdidos} P · {c.partidos} partidos juntos</span>
    </button>) : <p className="text-sm text-(--color-apagado)">Todavía no hay compañeros con suficientes partidos en este período para comparar.</p>}
    {pocos.length > 0 && <details className="rounded-xl border border-(--color-borde) px-3 py-2">
      <summary className="min-h-11 cursor-pointer py-2 text-sm">Jugaron poco ({pocos.length})</summary>
      <div className="flex flex-col gap-2">{pocos.map(c => <button type="button" key={c.id} onClick={() => onVerPerfil(c.id)}
        className="min-h-11 text-left text-sm"><b>{c.nombre}</b><span className="block text-xs text-(--color-apagado)">{c.ganados} G · {c.perdidos} P · {c.partidos} partidos juntos</span></button>)}</div>
      <p className="pb-1 text-xs text-(--color-apagado)">Todavía falta historia para comparar.</p>
    </details>}
  </div>;
}
